module.exports = __webpack_public_path__ + "img/profile-man-7-min.0692d51a.jpg";